import React from "react";

const ExistingPagesList = ({ pages, setMessage }) => {
  const copyToClipboard = async (text) => {
    try {
      await navigator.clipboard.writeText(text);
      setMessage("Link copied!");
    } catch (e) {
      console.error(e);
      setMessage("Copy failed.");
    }
  };

  return (
    <div className="pb-card">
      <h2>Existing Pages</h2>

      <div className="pb-list">
        {pages.map((p) => {
          const pagePath = `/p/${p.id}`;
          const fullUrl = `${window.location.origin}${pagePath}`;

          return (
            <div className="pb-list-item" key={p.id}>
              <div className="pb-list-title">{p.title}</div>
              <div className="pb-list-sub">{p.description || ""}</div>

              <div className="pb-page-link-row">
                <a className="pb-page-link" href={pagePath} target="_blank" rel="noreferrer">
                  {pagePath}
                </a>
                <button className="pb-copy-btn" onClick={() => copyToClipboard(fullUrl)}>
                  Copy
                </button>
              </div>
            </div>
          );
        })}

        {pages.length === 0 && <div className="pb-muted">No pages yet.</div>}
      </div>
    </div>
  );
};

export default ExistingPagesList;